import React, { useRef } from 'react';
import html2canvas from 'html2canvas';
import { useSelector } from 'react-redux';
import { IDCardService } from '../../services/idCard/idCard';

const IDCard = () => {
  const cardRef = useRef(null);
  const companyProfile = useSelector((state) => state?.dashboard?.appLayout?.companyProfile);
  const { data } = IDCardService.useGetIdCard();

  const handleSaveAsPNG = () => {
    if (cardRef.current) {
      // Temporarily set the background to transparent for capture
      const holder = cardRef.current.parentElement;
      const originalBackground = holder.style.backgroundColor;
      holder.style.backgroundColor = 'transparent';

      html2canvas(cardRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: null, // Explicitly set to null for transparency
        onclone: (document) => {
          document.body.style.backgroundColor = 'transparent';
          document.querySelector('.id-card-holder').style.backgroundColor = 'transparent';
          document.querySelector('.card-container').style.backgroundColor = 'transparent';
        }
      }).then(canvas => {
        const link = document.createElement('a');
        link.download = `${idCard.user_name}_ID_Card.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();

        // Restore original background
        holder.style.backgroundColor = originalBackground;
      }).catch(error => {
        console.error('Error generating PNG:', error);
        // Restore original background even if there's an error
        holder.style.backgroundColor = originalBackground;
      });
    }
  };
  const idCard = {
    user_name: data?.username,
    full_name: `${data?.name} ${data?.secondName}`,
    user_photo: data?.image,
    bda_user: data?.bdaUser,
    user_detail_address: data?.address,
    state_name: data?.state,
    user_detail_pin: data?.pin,
    user_detail_mobile: data?.mobile
  }

  if (!data || Object.keys(data).length === 0) {
    return (
      <div className="panel panel-default">
        <h2>
          Your ID Card is not Generated! <br />
          Please complete data like bank, Email, Phone, PAN, KYC and upload Profile Image,
          <br /> then only that need to be shared with the admin for approval
        </h2>
      </div>
    );
  }

  return (
    <div id="print_area" >
      <div id="widget" className="id-card-holder">
        {/* Container for both cards */}
        <div ref={cardRef} className="card-container">
          <div className="card">
            <div className="header">
              <img
                src={`/images/idcard-logo.png`}
                alt="ID Card Logo"
              />
            </div>
            <h2>IDENTITY CARD</h2>
            <div className="photo-container">
              <div className="photo">
                <img
                  src={idCard.user_photo}
                  alt="Profile"
                />
              </div>
            </div>
            <div className="info">
              <div>
                <p className="full-name">{idCard.full_name}</p>
                {idCard.bda_user === 'yes' && (
                  <p className="distributor">INDEPENDANT DISTRIBUTOR</p>
                )}
                <p className="id-number">ID NUMBER: {idCard.user_name}</p>
              </div>
            </div>
          </div>

          <div className="card bottom-card">
            <div className="info details">
              <div className="address">
                <h3 style={{ fontWeight: '600' }}>PERSONAL DETAILS</h3>
                <div className="data">
                  <p style={{ textTransform: 'uppercase' }}>{idCard.full_name}</p>
                  <p>{idCard.user_detail_address}</p>
                  <p>{idCard.state_name}</p>
                  <p>{idCard.user_detail_pin}</p>
                  {idCard.user_detail_mobile && (
                    <p>Mobile: {idCard.user_detail_mobile}</p>
                  )}
                  <br />
                  <p>*This ID card valid upto: 00/00/0000</p>
                </div>
              </div>
              <div className="double-line"></div>
              <div className="address" style={{ paddingTop: '10px' }}>
                <p className="company-name" style={{ fontSize: '20px' }}><strong>{companyProfile?.name}</strong></p>
                <p style={{ fontSize: '13px' }}>{companyProfile?.address}</p>
                <p className="website">Email: <span>{companyProfile?.email}</span></p>
                <p className="website">www.ayushnatura.com</p>
                <p className="website">www.ayushnatura.in</p>
              </div>
            </div>
          </div>
        </div>

        <div className="button-container">
          <button
            type="button"
            id="btnSave"
            className="btn"
            onClick={handleSaveAsPNG}
          >
            Save as PNG
          </button>
        </div>
      </div>

      <style jsx>{`
        .panel {
          margin: 20px;
          overflow-x: scroll;
        }

        .id-card-holder {
          width: 450px;
          padding: 4px;
          margin: 0 auto;
          // background-color: #008d92;
          border-radius: 5px;
          position: relative;
        }


        .card-container {
          background-color: #fff;
          padding: 10px;
          border-radius: 10px;
          text-align: center;
          box-shadow: 0 0 1.5px 0px #b9b9b9;
          display: flex;
          flex-direction: column;
          gap: 20px; /* Space between cards */
        }

        .card {
          background-color: #fff;
          text-align: center;
        }

        .bottom-card {
          padding: 30px;
        }

        .header {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 20px;
        }

        .header img {
          width: 270px;
          padding-top: 30px;
        }

        h2 {
          font-size: 22px;
          color: #000;
          font-weight: 600;
          margin: 5px 0;
        }

        h3 {
          font-size: 19px;
          margin: 2.5px 0;
          font-weight: 300;
          color: #000;
        }

        .photo-container {
          display: flex;
          justify-content: center;
          background: linear-gradient(180deg, #fff 35%, rgba(0,0,0,0) 35%, rgba(0,0,255,0) 35%, rgba(247, 235, 235, 0) 35%), 
                     linear-gradient(180deg, #f17172 45%, #fefffe 0%, #fff 50%, #009299 5%);
          margin-bottom: -1px;
        }

        .photo {
          width: 170px;
          height: 200px;
          background-color: #fff;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: bold;
          position: relative;
          border: 4px solid #fff;
          border-radius: 18px;
        }

        .photo img {
          width: 140px;
          height: 170px;
          overflow: hidden;
        }

        .photo:before {
          background: none;
          border: 4px solid #009299;
          content: "";
          display: block;
          position: absolute;
          top: 4px;
          left: 4px;
          right: 4px;
          bottom: 4px;
          pointer-events: none;
          border-radius: 9px;
        }

        .info {
          text-transform: uppercase;
          background: #009299;
          padding: 30px 10px;
          margin-top: 0;
        }

        .info.details {
          background: #fff;
          text-align: start;
        }

        .website{
        text-transform: initial !important;
        font-size: 13px !important;
        }

        .info p {
          margin: 0px 0;
        }

        .full-name {
          font-size: 35px;
          color: #fff;
          font-weight: 800;
        }

        .distributor {
          font-size: 22px;
          color: #fff;
        }

        .id-number {
          font-size: 22px;
          color: #fff;
        }

        .data {
          padding-top: 20px;
          padding-bottom: 20px;
        }

        .address p {
          font-size: 16px;
          color: #000;
          text-transform: capitalize;
        }

        .double-line {
          background: linear-gradient(180deg, #fff 35%, rgba(0,0,0,0) 35%, rgba(0,0,255,0) 35%, rgba(247, 235, 235, 0) 35%), 
                     linear-gradient(180deg, #f17172 50%, #fefffe 0%, #fff 60%, #009299 5%);
          height: 40px;
        }

        .button-container {
          text-align: center;
          padding: 20px;
        }

        .btn {
          background-color: black;
          color: #fff;
          padding: 10px 20px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        .btn:hover {
          opacity: 0.9;
        }
      `}</style>
    </div>
  )
};

export default IDCard;